var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"omapi-tabnav"},_vm._l((_vm.tabs),function(value,index){return _c('div',{key:index,staticClass:"omapi-tabnav__item",class:{ 'omapi-tabnav__item-active': _vm.isActive(index) },on:{"click":function($event){return _vm.$emit('go', index, $event)}}},[_vm._v(" "+_vm._s(value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }